import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { NavBarSwitch } from './index.styled'
import SwitchInputControlled from '../../Elements/inputs/SwitchInput/controlled'
import { setAppModal } from '../../../redux/action/system'
import { putAutoConfirmationThunk } from '../../../redux/thunk/order/acceptOrder'

const AutoConfirmationSwitch = React.memo(() => {
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const toggled = useSelector(store => store.system.toggled)
	const autoConfirmation = useSelector(store => store.autoConfirmationOrder.autoConfirmation)

	const handleChangeAcceptOrder = useCallback((e) => {
		if (e.target.checked) {
			dispatch(setAppModal({ autoConfirmationModalShow: true }))
		} else {
			dispatch(putAutoConfirmationThunk({ active: false, deliveryTime: autoConfirmation.deliveryTime, pickUpTime: autoConfirmation.pickUpTime }))
		}
	}, [autoConfirmation, dispatch])

	return (
		<NavBarSwitch className={toggled ? 'toggled' : ''}>
			<SwitchInputControlled label={t('LeftBar.menu.auto_confirmation')}
														 checked={autoConfirmation.active}
														 onChange={handleChangeAcceptOrder} />
		</NavBarSwitch>
	)
})

AutoConfirmationSwitch.displayName = 'AutoConfirmationSwitch'
export default AutoConfirmationSwitch
